import { render, staticRenderFns } from "./current-class-select.vue?vue&type=template&id=55ab5eac"
import script from "./current-class-select.vue?vue&type=script&lang=ts"
export * from "./current-class-select.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports